import { render } from "./IconBalloonPresentBox70px.vue?vue&type=template&id=1128f036"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__